import { Component, Input, OnDestroy, HostBinding, AfterViewInit, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthState } from '../../auth-state';
import { User } from '../../user';
import { AuthService } from '../../auth.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';

declare var $: any;

@Component({
  selector: 'app-confirm-sign-up',
  templateUrl: './confirm-sign-up.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmSignUpComponent extends AbstractForm implements OnDestroy, OnInit {

  showStates = [AuthState.CONFIRM_SIGN_UP];
  _show: boolean = false;
  submitted: boolean;
  code_sent: boolean = false;
  code_correct = false;
  messageSubscription:Subscription;
  message = '';
  loaded: boolean = false;

  private username = '';
  @HostBinding('className') className = '';

  constructor(
    private changeDetector: ChangeDetectorRef,
    protected formBuilder: FormBuilder,
    logger: LoggerService,
    protected authService: AuthService,
    protected route: ActivatedRoute) {

      super(formBuilder, logger);
  
      this.messageSubscription = authService.messages$.subscribe(msg => {
        this.message = msg?.msg || '';
        if(this.loaded){
          this.changeDetector.detectChanges();
          if(msg?.code == "CodeMismatchException")
            this.ngOnInit();
        }
      });

  }
  ngOnDestroy(){
    this.messageSubscription.unsubscribe();
  }

  @Input()
  set authState(authState: AuthState) {
    this._show = this.showStates.filter(item => item === authState.state).length > 0;
    if(this._show){
      this.username = authState.user.username;
    }
    this.className = this._show? 'active' : '';
  }

  ngOnInit(){
    if(this._show){   
      this.loaded = true;    
      setTimeout(() => {
        $('.codeInput').val('').focus();
      }, 200);
    }
  }
  

  buildFormGroup(): FormGroup {
    return this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(6)]]
    });

  }
  updateControls() {
    
  }
  updateObject():any {}


  getUser(): User {
    const u = new User();
    u.username = this.username;
    u.verificationCode = this.getControlValue('code').toString();
    return u;
  }

  onConfirm() {
    if(this.formGroup.invalid)
      return ;
    
    this.submitted = true;
    this.authService.confirmSignUp(this.getUser())
      .then((result) => { 
        
      })
      .catch(err => {
        if(err.code=="CodeMismatchException")
          this.code_correct=false;

        if(err.code=="LimitExceededException")
          this.code_correct=true;

        if(err.code == "ExpiredCodeException"){
            this.code_sent = false;
            this.message = 'Código expirado, toque em reenviar código';
            this.setControlValue('code','');
        }
      })
      .finally(() => this.submitted = false);
  }

  onResend() {
    this.code_sent = true;
    this.authService.resendSignUp(this.getUser());
  }

  onSignIn() {
    this.authService.changeAuthState(AuthState.SIGN_IN, null);
  }
}
